import React from 'react';
import Modal from 'react-modal';
import { isMobile } from 'react-device-detect';

export const setModalStyles: (styles: IModalStylesInput) => Modal.Styles = (
  styles,
): IModalStylesInput => ({
  overlay: {
    background: 'linear-gradient(to left, #61d183, #294fbf)',
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    ...styles.overlay,
  },
  content: {
    outline: 'none',
    margin: 'auto',
    width: isMobile ? 'unset' : '100%',
    maxWidth: isMobile ? 'calc(100% - 10px)' : '600px',
    maxHeight: isMobile ? 'calc(100% - 10px)' : 'calc(100% - 20px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: '#FFF',
    borderRadius: 20,
    overflow: 'hidden',
    top: 'auto',
    bottom: 'auto',
    left: isMobile ? 20 : 60,
    right: isMobile ? 20 : 60,
    border: 'none',
    padding: 0,
    ...styles.content,
  },
});

export interface IModalStylesInput {
  overlay?: React.CSSProperties;
  content?: React.CSSProperties;
  height?: string;
  width?: string;
  padding?: React.CSSProperties;
}
